var parent = require('../es/parse-int');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/parse-int.js
// module id = 893
// module chunks = 168707334958949